import React from 'react';
import {
  Box,
  Container,
  Flex,
  Heading,
  Img,
  Text,
  Link,
} from '@chakra-ui/react';

const FundInFocusAnicut = () => {
  return (
    <>
      <Flex
        as="section"
        flexDirection="column"
        overflow="hidden"
        justify="center"
        height={{ xs: '450px', sm: '300px' }}
        minH={{ xs: '450px', sm: '300px' }}
        maxH="450px"
        pos="relative"
      >
        <Img
          pos="absolute"
          objectFit="cover"
          src="/jpg/blogBanner.jpg"
          alt="members-hero"
          height="100%"
          width="100%"
        />
        <Box
          bg="linear-gradient(93.48deg, #00001F 45.8%, #186658 74.6%)"
          pos="absolute"
          height="100%"
          width="100%"
          opacity="0.7"
        />
        <Container
          maxW="container.xl"
          position="relative"
          zIndex="1"
          flexDir="column"
          px={{ xs: '20px', sm: '28px', md: '45px', lg: '60px', xl: 'inherit' }}
        >
          <Heading
            as="h1"
            mb="20px"
            variant="reportCardTitle"
            fontSize={{ xs: '26px', sm: '28px', md: '32px', lg: '38px' }}
            color="white"
            lineHeight={{ xs: '34px', md: '39px', lg: '42px' }}
          >
            {/* Fund in Focus: A Deep Dive into Elevar Equity&apos;s 15+ Year
            Journey of Impactful Investments */}
            Fund in Focus: Rising from the Dry Powder: Anicut Capital&apos;s
            Strategic Approach to India&apos;s Start-up Surge
          </Heading>
        </Container>
      </Flex>
      <Container
        as="section"
        maxW="container.xl"
        pb="80px"
        pt="40px"
        minH="420px"
        display={{ xs: 'flex', md: 'inherit' }}
        flexDirection="column"
      >
        <Box as="main" w="100%" pb="40px">
          <Text variant="blogAnswer">
            Welcome to our ‘Fund in Focus’ series where we profile our member
            funds, underscore their investment philosophy, and highlight some of
            their interesting work. Today we speak to Ashvin Chadha, Managing
            Partner & Co-Founder,{' '}
            <Link
              href={'https://www.anicutcapital.com/'}
              target="_blank"
              style={{
                textDecoration: 'underline',
              }}
              rel="noreferrer"
            >
              Anicut Capital.
            </Link>{' '}
            He throws light on how Anicut Capital prioritizes India's digital
            ecosystem, leveraging its vast potential while navigating challenges
            with a strategic, selective approach. The fund remains optimistic
            about India's startup landscape despite market fluctuations,
            focusing on sustainable, high-growth ventures for long-term success.
          </Text>
        </Box>

        <Box
          backgroundImage={`url('/jpeg/anicut-ashvin.jpeg')`}
          float={{ xs: 'right', md: 'left' }}
          alignSelf={{ xs: 'center', md: 'flex-start' }}
          mx={{ xs: '0px', md: '0px' }}
          mr={{ xs: '0px', md: '40px', lg: '60px', xl: '70px' }}
          mb="20px"
          width="300px"
          height="300px"
          backgroundRepeat="no-repeat"
          backgroundSize="cover"
          rounded="full"
        ></Box>
        <Flex flexDir={{ xs: 'column', lg: 'row' }} rowGap="16px">
          <Heading
            textAlign={{ xs: 'center', md: 'left' }}
            fontWeight="800"
            color="blue.400"
          >
            Spokesperson: Ashvin Chadha, Managing Partner & Co-Founder, Anicut
            Capital
          </Heading>
        </Flex>
        <Box>
          <Box
            ml={{ xs: 'auto', md: '345px', lg: '370px' }}
            mr={{ xs: 'auto', md: '0px' }}
            width={{ xs: '160px', md: '80px' }}
            h="2px"
            bgColor="primary.500"
            borderRadius="5px"
            mt={{ xs: '16px', md: '10px' }}
            mb="15px"
          />
          <Box mt="16px" mb="20px">
            <Heading variant="blogQuestion" mb="20px">
              1. What is the core mission and philosophy behind Anicut Capital?
            </Heading>
            <Text variant="blogAnswer">
              Anicut Capital is an asset management company managing multiple
              AIFs across both debt and equity strategies. Anicut currently
              manages three debt funds (GAF-1, GAF-2, and GAF-4), a seed fund
              (GAAF), and an early growth equity fund (GAF-3), with a cumulative
              AUM of Rs 3,000 crores and has invested in early and growth
              startups and MSMEs. Anicut's portfolio includes companies like
              Milky Mist, Wow! Momo, Axiscades, Kaynes, Bira, Sugar Cosmetics,
              Wingreens, Blue Tokai, Sharechat, Mcaffeine, Milky Mist, XYXX,
              Curatio Healthcare and Agnikul, among others.
              <br />
              <br />
              The name "Grand Anicut" draws inspiration from the ancient
              engineering marvel "Kallanai", one of the world's oldest
              functional water regulating structures in Tamil Nadu, India. As a
              specialized alternative investments firm, Anicut embodies the
              principles of innovation, excellence, and resilience showcased by
              Kallanai. We seek forward-thinking companies poised for growth in
              India to generate long-term value for our investors, and partners.
              With a collaborative and partnership-oriented approach, Anicut is
              committed to fostering success in its investments and making a
              positive impact on communities and the world
            </Text>
          </Box>
          {/* Question 2 */}
          <Box my="16px">
            <Heading variant="blogQuestion" pb="20px" pt="12px">
              2. How does Anicut Capital spot its ‘winning start-ups’?
            </Heading>
            <Text variant="blogAnswer" py="16px">
              Our criteria vary across our 3 investment strategies – seed, early
              growth, and private credit
            </Text>
            <Text variant="blogAnswer" mt="16px" mb="8px">
              In the seed stage, since the companies are early-stage and don’t
              have a lot of history, we spend a lot of time understanding the
              founding team quality, their past experiences, clarity of the
              long-term vision, ability to execute and overall “mentor-ability”
              of the founders. We like large and growing markets both in India
              and abroad and companies that have a unique patent/IP or unique
              approach to solving a problem
              <br />
              <br />
              In the early-growth stage (Series A), we look at businesses with a
              proven and scalable business model, established product market fit
              and sustained traction and growth. We like businesses with high
              gross margins and sustainable cost structures with acceptable
              levels of burn and a clear path to profitability
              <br />
              <br />
              In private credit, we look for businesses that have demonstrated
              consistent growth and profitability through the years. We like
              businesses that are emerging as market leaders in their respective
              verticals and have reputed promoters with high levels of integrity
              and market credibility. Importantly, we look for consistent cash
              flows and profitable business models that have the opportunity for
              continued margin expansion and cash flow generation.
            </Text>
          </Box>

          {/* Question 3 */}
          <Box my="16px">
            <Heading variant="blogQuestion" pt="28px">
              3. Anicut Capital last year raised funds from HDFC AMC’s Fund of
              Fund. Tell us how the fund plans to deploy the capital.
            </Heading>
            <Text variant="blogAnswer" mt="16px" mb="8px">
              Anicut Capital’s Equity Fund received a significant commitment
              from HDFC AMC's Fund of Fund last year. The investment will be
              made from HDFC AMC’s Select AIF FOF-I which invests in Category I
              and II Venture Capital/Private equity-oriented AIFs. Anicut’s
              Equity Fund was launched in June 2022, with a total corpus of Rs.
              500 crores, including an additional Rs. 250 crore green shoe
              option.
              <br />
              <br />
              The capital will be deployed in early growth companies across
              various sectors by Anicut Equity Fund. The fund has already
              deployed over Rs. 150 crores in seven promising companies,
              including Blue Tokai, Earth Rhythm, Neeman’s, XYXX, Wheelocity,
              The Ayurveda Experience (TAE) and Illumine-i and aims to pursue
              early growth investments in a total of 12-14 companies, both
              within and beyond Anicut’s seed portfolio. The fund's focus is on
              diverse sectors such as Consumer, Internet, Technology, and B2B
              among others.
            </Text>
          </Box>

          {/* Question 4 */}
          <Box my="16px">
            <Heading variant="blogQuestion" pt="16px">
              4. How do you navigate challenges in the ever-evolving landscape
              of investments?
            </Heading>
            <Text variant="blogAnswer" py="16px">
              We have an agile, strategic, and adaptive approach towards
              investing and are constantly trying to learn and stay abreast of
              the latest trends and developments. We conduct thorough market
              research to understand current trends, regulatory changes, and
              emerging opportunities. We have now accumulated deep expertise in
              specific sectors or industries to identify promising investment
              opportunities. We look to build strong relationships with local
              partners, co-investors, and industry experts to gain insights into
              the market and access deal flow. Being a sector-agnostic fund
              investing across stages, our breadth of capabilities and large
              network enable us to leverage the knowledge and resources that
              reside in our ecosystem.
            </Text>
          </Box>
          {/* Question 5 */}
          <Box my="16px">
            <Heading variant="blogQuestion" pt="16px">
              5. What excites Anicut Capital about the ‘India opportunity’ in
              the growing digital ecosystem?
            </Heading>
            <Text variant="blogAnswer" py="16px">
              India has a massive and rapidly expanding population, making it
              one of the largest consumer markets globally. The increasing
              adoption of digital technologies, rising disposable incomes, and a
              burgeoning middle class present a vast market for various products
              and services, especially in the digital space. India has also
              undergone a significant digital transformation across sectors such
              as finance, healthcare, education, and e-commerce, driven by the
              “India Stack” of public digital infrastructure. Increasing
              internet penetration, driven by affordable smartphones and data
              presents a huge opportunity for digital businesses, including
              e-commerce platforms, fintech companies, and content providers, to
              reach and serve a broader audience. D2C, space-tech, clean-tech,
              and tech services have been some sectors of interest in the recent
              past and we feel these sectors will have some extraordinary
              businesses
              <br />
              <br />
              While the ‘India opportunity’ is promising, we also recognize
              unique challenges to India, such as regulatory complexities and
              competition. However, our overall optimism stems from the belief
              that the evolving digital ecosystem in India has the potential to
              drive substantial ROI for those willing to navigate and invest
              strategically in this dynamic market
            </Text>
          </Box>
          {/* Question 6 */}
          <Box my="16px">
            <Heading variant="blogQuestion" pt="16px">
              6. Share some of your portfolio companies recent work which you
              are extremely excited about
            </Heading>
            <Text variant="blogAnswer" py="16px">
              <Text as="span" variant="blogQuestion" fontWeight="700">
                Neeman’s:
              </Text>{' '}
              Neeman’s is India's largest emerging sustainability-oriented
              footwear brand. The five-year-old company makes footwear from
              Merino wool, organic cotton, recycled PET bottles, and recycled
              tyres. We are particularly excited that the company recently
              forayed into the offline channel with a new store in Hyderabad and
              is getting a tremendously positive response.
            </Text>
            <Text variant="blogAnswer" py="16px">
              <Text as="span" variant="blogQuestion" fontWeight="700">
                CapGrid:
              </Text>{' '}
              CapGrid is a Gurugram-based automotive and industrial sourcing and
              procurement technology start-up. We are very excited that they
              have outlined an ambitious future growth strategy. aims to solve
              OEMs’ complexity challenges with respect to low-value parts such
              as fasteners, gaskets, bearings, and wiring connectors among other
              small components that belong to the tail (approximately 10-15%) of
              an OEM’s direct material spend in production of a new vehicle.
            </Text>
            <Text variant="blogAnswer" py="16px">
              <Text as="span" variant="blogQuestion" fontWeight="700">
                Agnikul:
              </Text>{' '}
              Agnikul is a space tech startup specializing in the design,
              manufacture, testing, and launching of orbital-class rockets. The
              company has strong IP around the world’s first 3D printed rockets.
              We are excited that preparations are in the final stages by for
              the maiden launch of India's first-ever private launchpad and the
              second rocket launch by a private sector player
            </Text>
            <Text variant="blogAnswer" py="16px">
              <Text as="span" variant="blogQuestion" fontWeight="700">
                Illumine-i:
              </Text>{' '}
              Illumine-i: Illumine-i is a leading sustainable design and
              engineering firm that started with a focus on designing
              low-voltage power plants. In the past few years, Illumine-i has
              become the leading player in its category, offering structural &
              electrical engineering expertise for power plants (LV, MV, HV),
              power storage devices, distribution components, infrastructure
              projects and project delivery consultancy.
            </Text>
          </Box>
          {/* Question 7 */}
          <Box my="16px">
            <Heading variant="blogQuestion" pt="16px">
              7. Reeling from the funding winter, there is record dry powder
              with a high potential for investing in the Indian startup
              ecosystem. What is your take on this phenomenon and how is Anicut
              Capital approaching it?
            </Heading>
            <Text variant="blogAnswer" py="16px">
              While there continues to be significant interest and confidence in
              India's startup ecosystem, we have become more strategic,
              selective and discerning in our investment decisions and are
              choosing companies with high growth potential, innovative
              solutions, and long-term business plans. We are also working
              closely with our portfolio companies to ensure they are
              well-positioned to weather economic uncertainties. While
              short-term challenges may exist, the focus remains on identifying
              businesses with the potential for sustained success over time.
            </Text>
          </Box>
        </Box>
        <Heading
          variant="blogQuestion"
          lineHeight="30px"
          pt="16px"
          fontStyle="italic"
          p="12px 12px 0px"
        >
          The content in this section is curated by Team IVCA. For any feedback,
          connect with&nbsp;
          <Link
            href="mailto:paromita.sinha@ivca.in"
            target="_blank"
            style={{ color: 'blue', textDecoration: 'underline' }}
          >
            paromita.sinha@ivca.in
          </Link>
        </Heading>
      </Container>
    </>
  );
};

export default FundInFocusAnicut;
